<template>
  <Modal
    @close="$emit('close')"
    :classes="'col-md-4'"
    title="Asignación de rating"
  >
    <div slot="body">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <i
              class="fas fa-star pointer"
              v-for="(item, i) in new Array(5)"
              :class="{
                'text-secondary': i + 1 <= marked,
                'text-gray': i + 1 > marked,
              }"
              @mouseenter="marked = i + 1"
              @mouseleave="marked = 0"
              :key="i"
              @click="setRating(i + 1)"
            />
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/Modal";

export default {
  name: "RatingModal",
  components: {
    Modal,
  },
  props: ["bookData"],
  data() {
    return {
      data: null,
      marked: 0,
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  methods: {
    async setRating(rating) {
      let action = "updateBookRating";
      let method = "put";

      if (this.data.rating == 0) {
        action = "addBookRating";
        method = "post";
      }

      let apiUrl = `${this.dataUrl}/bookRating/${action}`;
      let apiData = {
        book: {
          id: this.data.id,
        },
        bookUser: {
          id: this.teacherData.id,
        },
        rating: rating,
        description: "",
      };

      let loader = this.$loading.show();

      try {
        let { data } = await this.axios[method](apiUrl, apiData);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.$notify({
            title: ["Libro puntuado exitosamente"],
            type: "success",
          });

          this.$emit("setRating", data.content.rating);
        } else {
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
  mounted() {
    this.data = this.bookData;
  },
};
</script>
